import * as React from 'react';
import styles from './Columns.module.scss';
import { ColorStatus } from '../../../_helpers';

const renderRow = (row: ColorStatus | string | undefined) => {
    if (row instanceof ColorStatus) {
        return (
          <span style={{ color: `var(${row.color})` }}>
              {row.text}
          </span>
        );
    }
    return row;
};

const MultiRowColumn: React.FC<IProps> = ({ rows }) => (
  <div className={styles.qualification}>
      <div className={styles.qualification__name}>
          {renderRow(rows[0])}
      </div>
      <div className={styles.qualification__centerName}>
          {renderRow(rows[1])}
      </div>
      <div className={styles.qualification__address}>
          {renderRow(rows[2])}
      </div>
  </div>
);

interface IProps {
    rows: (ColorStatus | string | undefined)[];
}

export default MultiRowColumn;
